(function ($) {

'use strict';

	/**
	 * check for IE browser 
	 * @returns {Boolean}
	 */
	$.isIE = function () {

		var ua = window.navigator.userAgent;
		var msie = ua.indexOf('MSIE ');

		if (msie > 0 || navigator.userAgent.match(/Trident.*rv\:11\./)) {      // If Internet Explorer, return version number
			return true;
		} else {           // If another browser, return 0
			return false;
		}

	}; // $.isIE

}(jQuery));